module.exports = window.PubSub;